import axios from "axios";
import React, { useState, useEffect } from "react";
import GreenSpinner from "../../../Shared/Loading/GreenSpinner";
import { Link } from "react-router-dom";

const AdminDashGreenMain = () => {
  const [jobSummary, setJobSummary] = useState(null);
  const [appliedSummary, setAppliedSummary] = useState(null);
  const [invoiceSummary, setinvoiceSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Define the fetch function
    const fetchJobSummary = async () => {
      try {
        const response = await fetch(
          "https://tutor-tree-server-1.vercel.app/new-jobs-summary?page=1&limit=20"
        ); // Adjust query params as needed
        if (!response.ok) {
          throw new Error("Failed to fetch job summary");
        }
        const data = await response.json();
        setJobSummary(data.summary); // Save the summary data
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    // Call the fetch function
    fetchJobSummary();
  }, []);
  useEffect(() => {
    // Define the fetch function
    const fetchJobSummary = async () => {
      try {
        const response = await fetch(
          "https://tutor-tree-server-1.vercel.app/applied-summary?page=1&limit=20"
        ); // Adjust query params as needed
        if (!response.ok) {
          throw new Error("Failed to fetch job summary");
        }
        const data = await response.json();
        setAppliedSummary(data.summary); // Save the summary data
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    // Call the fetch function
    fetchJobSummary();
  }, []);
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const response = await axios.get(
          "https://tutor-tree-server-1.vercel.app/invoiceSummary"
        );
        setSummary(response.data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, []);

  if (loading) return <GreenSpinner></GreenSpinner>;
  if (error) return <div>Error: {error}</div>;
  if (!summary)
    return (
      <div>
        {" "}
        <GreenSpinner></GreenSpinner>{" "}
      </div>
    );
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  // Calculate total leads by summing individual lead types
  const totalLeads = jobSummary
    ? (jobSummary.newLeads || 0) +
      (jobSummary.publish || 0) +
      (jobSummary.cancelled || 0)
    : 0;

  return (
    <div>
      <div className="w-full h-20 flex justify-start pl-5 items-center bg-gree-100 shadow-md">
        <h2 className="text-xl text600 text-start text-green-900 font-montserrat ">
          Admin Dashboard
        </h2>
      </div>
      <div className="mx-5 my-10">
        <h1 className="text-2xl font-montserrat text-green-900 text500 my-4">
          Leads Summary
        </h1>
        <div>
          {jobSummary && (
            <div className="grid grid-cols-4 gap-5">
              <Link to="/dashboardTwo/AdminLeads">
                <div className="w-full h-32 bg-white shadow-sm rounded-lg flex flex-col  justify-center hover:bg-green-200 duration-150 gap-2  py-4 px-8">
                  <h1 className="text-4xl text600 text-green-900 font-montserrat">
                    {totalLeads}
                  </h1>
                  <h1 className="text-xl text600 text-green-700 font-montserrat">
                    Total Leads
                  </h1>
                </div>
              </Link>
              <Link to="/dashboardTwo/AdminLeads">
                {" "}
                <div className="w-full h-32 bg-white shadow-sm rounded-lg flex flex-col  justify-center hover:bg-green-200 duration-150 gap-2 py-4 px-8">
                  <h1 className="text-4xl text600 text-green-900 font-montserrat">
                    {jobSummary.newLeads}
                  </h1>
                  <h1 className="text-xl text600 text-green-700 font-montserrat">
                    New Leads
                  </h1>
                </div>
              </Link>
              <Link to="/dashboardTwo/AdminLeads">
                <div className="w-full h-32 bg-white shadow-sm rounded-lg flex flex-col  justify-center hover:bg-green-200 duration-150 gap-2 py-4 px-8">
                  <h1 className="text-4xl text600 text-green-900 font-montserrat">
                    {jobSummary.publish}
                  </h1>
                  <h1 className="text-xl text600 text-green-700 font-montserrat">
                    Published
                  </h1>
                </div>
              </Link>
              <Link to="/dashboardTwo/AdminLeads">
                <div className="w-full h-32 bg-white shadow-sm rounded-lg flex flex-col  justify-center hover:bg-green-200 duration-150 gap-2 py-4 px-8">
                  <h1 className="text-4xl text600 text-green-900 font-montserrat">
                    {jobSummary.cancelled}
                  </h1>
                  <h1 className="text-xl text600 text-green-700 font-montserrat">
                    Cancelled
                  </h1>
                </div>
              </Link>

            </div>
          )}
        </div>
        <h1 className="text-2xl font-montserrat text-green-900 text500 my-4 mt-16">
          Applied Tutor Summary
        </h1>
        <div>
          {appliedSummary && (
            <div className="grid grid-cols-3 gap-5">
              <Link to="/dashboardTwo/AdminAllApplication">
                <div className="w-full h-32 bg-white shadow-sm rounded-lg flex flex-col  justify-center hover:bg-green-200 duration-150 gap-2  py-4 px-8">
                  <h1 className="text-4xl text600 text-green-900 font-montserrat">
                    {appliedSummary.applyData}
                  </h1>
                  <h1 className="text-xl text600 text-green-700 font-montserrat">
                    Application
                  </h1>
                </div>
              </Link>
              <Link to="/dashboardTwo/AdminSortListed">
                {" "}
                <div className="w-full h-32 bg-white shadow-sm rounded-lg flex flex-col  justify-center hover:bg-green-200 duration-150 gap-2 py-4 px-8">
                  <h1 className="text-4xl text600 text-green-900 font-montserrat">
                    {appliedSummary.greenShortlistedAll}
                  </h1>
                  <h1 className="text-xl text600 text-green-700 font-montserrat">
                    Shortlisted
                  </h1>
                </div>
              </Link>
              <Link to="/dashboardTwo/AdminClassBooked">
                <div className="w-full h-32 bg-white shadow-sm rounded-lg flex flex-col  justify-center hover:bg-green-200 duration-150 gap-2 py-4 px-8">
                  <h1 className="text-4xl text600 text-green-900 font-montserrat">
                    {appliedSummary.greenClassBookedAll}
                  </h1>
                  <h1 className="text-xl text600 text-green-700 font-montserrat">
                    ClassBooked
                  </h1>
                </div>
              </Link>
            

            </div>
          )}
        </div>
        <h1 className="text-2xl font-montserrat text-green-900 text500 my-4 mt-16">
         Invoice Summary
        </h1>
        <div>
          {appliedSummary && (
            <div className="grid grid-cols-4 gap-4">
              <Link to="/dashboardTwo/AdminAllInvoice">
                <div className="w-full h-32 bg-white shadow-sm rounded-lg flex flex-col  justify-center hover:bg-green-200 duration-150 gap-2  py-4 px-8">
                
                  <h1 className="text-4xl text600 text-green-900 font-montserrat">
                   {summary.newInvoice.totalSalary.toLocaleString()} TK
                  </h1>
                  <h1 className="text-xl text600 text-green-700 font-montserrat">
                   Total Tutor Salary ( {summary.newInvoice.totalCount} )
                  </h1>
                </div>
              </Link>
              <Link to="/dashboardTwo/AdminAllInvoice">
                <div className="w-full h-32 bg-white shadow-sm rounded-lg flex flex-col  justify-center hover:bg-green-200 duration-150 gap-2  py-4 px-8">
                
                  <h1 className="text-4xl text600 text-green-900 font-montserrat">
                    {summary.dueInvoice.totalSalary.toLocaleString()} TK
                  </h1>
                  <h1 className="text-xl text600 text-green-700 font-montserrat">
                    Due Invoice ( {summary.dueInvoice.totalCount} )
                  </h1>
                </div>
              </Link>
              <Link to="/dashboardTwo/AdminAllInvoice">
                <div className="w-full h-32 bg-white shadow-sm rounded-lg flex flex-col  justify-center hover:bg-green-200 duration-150 gap-2  py-4 px-8">
                
                  <h1 className="text-4xl text600 text-green-900 font-montserrat">
                   {summary.overdueInvoice.totalSalary.toLocaleString()} TK
                  </h1>
                  <h1 className="text-xl text600 text-green-700 font-montserrat">
                   Over Due Invoice  ( {summary.overdueInvoice.totalCount} )
                  </h1>
                </div>
              </Link>
              <Link to="/dashboardTwo/AdminAllInvoice">
                <div className="w-full h-32 bg-white shadow-sm rounded-lg flex flex-col  justify-center hover:bg-green-200 duration-150 gap-2  py-4 px-8">
                
                  <h1 className="text-4xl text600 text-green-900 font-montserrat">
                   {summary.paidInvoice.totalSalary.toLocaleString()} TK
                  </h1>
                  <h1 className="text-xl text600 text-green-700 font-montserrat">
                   Paid Invoice ( {summary.paidInvoice.totalCount} )
                  </h1>
                </div>
              </Link>
            
            

            </div>
          )}
        </div>
     
      
        
      </div>
    </div>
  );
};

export default AdminDashGreenMain;
